import React from 'react';
import { Flex, Badge } from '@spothero/ui';
import useIsMobile from 'hooks/use-is-mobile';
const AirportSpotTag = ({ tag, spotsLeft, title }) => {
    const isMobile = useIsMobile();
    const message = spotsLeft > 1 ? 'Spots Left' : 'Spot Left';
    const styles = {
        py: '1px',
        px: '2',
        textAlign: 'center',
        backgroundColor: 'black',
        color: 'white',
        borderRadius: 'base',
        fontSize: 'xs',
        fontWeight: 'semibold',
    };
    if (!tag && !spotsLeft) {
        return null;
    }
    return (<Flex mx={isMobile ? '3' : '4'} mt={isMobile ? '3' : '4'} 
    // This negative margin is to offset the padding of the FacilitySummary container
    mb={isMobile ? '-1' : '-2'} className="AirportSpotTag" data-testid={`AirportTag-${encodeURIComponent(title)}`}>
            {tag && (<Badge {...styles} mr="2">
                    {tag}
                </Badge>)}
            {spotsLeft && (<Badge {...styles}>
                    {spotsLeft} {message}
                </Badge>)}
        </Flex>);
};
export default AirportSpotTag;
